// GLOBALS
// Initial State
let initialState = {
  invoices: [],
  fetching: false,
  error: null
}

const RESET_ERROR = 'RESET_ERROR';
// GET Commissions Reports
const GET_DELIVERY_INVOICES = 'GET_DELIVERY_INVOICES';
const GET_DELIVERY_INVOICES_SUCCESS = 'GET_DELIVERY_INVOICES_SUCCESS';
const GET_DELIVERY_INVOICES_FAILURE = 'GET_DELIVERY_INVOICES_FAILURE';
// GET PDP Commissions Reports
const GET_PDP_INVOICES = 'GET_PDP_INVOICES';
const GET_PDP_INVOICES_SUCCESS = 'GET_PDP_INVOICES_SUCCESS';
const GET_PDP_INVOICES_FAILURE = 'GET_PDP_INVOICES_FAILURE';
// GET Commission Report PDF link
const GET_DELIVERY_INVOICE_DOWNLOAD_LINK = 'GET_DELIVERY_INVOICE_DOWNLOAD_LINK';
const GET_DELIVERY_INVOICE_DOWNLOAD_LINK_SUCCESS = 'GET_DELIVERY_INVOICE_DOWNLOAD_LINK_SUCCESS';
const GET_DELIVERY_INVOICE_DOWNLOAD_LINK_FAILURE = 'GET_DELIVERY_INVOICE_DOWNLOAD_LINK_FAILURE';

export const resetError = () => {
  return {
    type: RESET_ERROR
  };
};

export const getDeliveryInvoices = (orgID) => {
  return ({
    types: [GET_DELIVERY_INVOICES, GET_DELIVERY_INVOICES_SUCCESS, GET_DELIVERY_INVOICES_FAILURE],
    payload: {
      request: {
        url: `/invoices?organisation_id=${orgID}&type=paid_delivery`,
        method: 'GET',
      }
    }
  });
};

export const getPDPInvoices = (orgID) => {
  return ({
    types: [GET_PDP_INVOICES, GET_PDP_INVOICES_SUCCESS, GET_PDP_INVOICES_FAILURE],
    payload: {
      request: {
        url: `/invoices?organisation_id=${orgID}&type=delivery_partner`,
        method: 'GET',
      }
    }
  });
};

export const getDeliveryInvoiceDownloadLink = (invoice, callback) => {
  return ({
    types: [GET_DELIVERY_INVOICE_DOWNLOAD_LINK, GET_DELIVERY_INVOICE_DOWNLOAD_LINK_SUCCESS, GET_DELIVERY_INVOICE_DOWNLOAD_LINK_FAILURE],
    payload: {
      request: {
        url: `/invoices/${invoice._id}`,
        method: 'GET',
      }
    },
    callback
  });
};

const invoicesReducer = (state = initialState, action) => {
  switch (action.type) {
    case RESET_ERROR:
      return {
        ...state, error: null
      };
    case GET_DELIVERY_INVOICES:
    case GET_PDP_INVOICES:
      return {
        ...state,
        fetching: true
      };
    case GET_DELIVERY_INVOICES_SUCCESS:
      return {
        ...state,
        fetching: false,
        invoices: action.payload.data.data
      };
    case GET_PDP_INVOICES_SUCCESS:
      return {
        ...state,
        fetching: false,
        pdp_invoices: action.payload.data.data
      };
    case GET_DELIVERY_INVOICES_FAILURE:
    case GET_PDP_INVOICES_FAILURE:
      return {
        ...state,
        fetching: false,
        error: action?.error?.response?.data?.error?.text
      };
    case GET_DELIVERY_INVOICE_DOWNLOAD_LINK:
      return {
        ...state,
        fetching: true
      };
    case GET_DELIVERY_INVOICE_DOWNLOAD_LINK_SUCCESS:
      action.meta.previousAction.callback({ ...action.payload.data });
      return {
        ...state,
        fetching: false
      };
    case GET_DELIVERY_INVOICE_DOWNLOAD_LINK_FAILURE:
      return {
        ...state,
        fetching: false,
        error: action?.error?.response?.data?.error?.text
      };
      default:
        return state
  }
};

export default invoicesReducer;
